/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */
import InterpretingServiceDTO from "./InterpretingServiceDTO";
import LanguageProficiencyDTO from "./LanguageProficiencyDTO";


interface InterpreterDisplayResponse {
  /** Pulled from the PublicID field, not the id field */
  id: string;
  /** An easy to display name, possibly set by the user in a future revision */
  displayName: string | null;
  gender: string | null;
  profilePictureUrl: string | null;
  interpretingServices: InterpretingServiceDTO[];
  languageProficiencies: LanguageProficiencyDTO[];
}
const InterpreterDisplayResponse = {
  create: (initValues?: Partial<InterpreterDisplayResponse> | null): InterpreterDisplayResponse => {
    const defaults: InterpreterDisplayResponse = {
      id: "",
      displayName: null,
      gender: null,
      profilePictureUrl: null,
      interpretingServices: [],
      languageProficiencies: [],
    };
    const fixedValues: Partial<InterpreterDisplayResponse> = initValues != null
      ? {
        interpretingServices: (initValues.interpretingServices ?? []).map(InterpretingServiceDTO.create) as InterpretingServiceDTO[],
        languageProficiencies: (initValues.languageProficiencies ?? []).map(LanguageProficiencyDTO.create) as LanguageProficiencyDTO[],
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default InterpreterDisplayResponse;
